// extracted by mini-css-extract-plugin
export default {"ota-card":"components-settings-competitors-competitor-panel-module__ota-card","not-available":"components-settings-competitors-competitor-panel-module__not-available"};